<ng-container *ngIf="!isLoading">
   
    <div>
      <div class="container" id="print-section1">
        <table class="table table-bordered">
          <thead>
            

     <tr>
            <th [attr.colspan]="totalth - 0" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग
            </th>

            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ today | date:'dd-MM-yyyy' }}
            </th>
          </tr>

            <tr>
            <th [attr.colspan]="totalth - 3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ - जिल्हानुसार 
              <span *ngIf="appliedFilters">
                    <small>
                        <!-- <span *ngIf="appliedFilters.country"> |<strong>देश:</strong>  {{ appliedFilters.country }}</span>
                        <span *ngIf="appliedFilters.state"> | <strong>राज्य:</strong> {{ appliedFilters.state }}</span>
                        <span *ngIf="appliedFilters.district"> |<strong>जिल्हा:</strong> {{ appliedFilters.district }}</span>
                        <span *ngIf="appliedFilters.taluka"> | <strong>तालुका:</strong> {{ appliedFilters.taluka }}</span>
                        <span *ngIf="appliedFilters.subscriptionType"> |<strong>वर्गणी प्रकार:</strong>  {{ appliedFilters.subscriptionType }}</span>
                        <span *ngIf="appliedFilters.rep"> | <strong>प्रतिनिधी: </strong> {{ appliedFilters.rep }}</span>
                        <span *ngIf="appliedFilters.officerep"> |<strong>कार्यालय प्रतिनिधी:</strong> {{ appliedFilters.officerep }}</span>
                        <span *ngIf="appliedFilters.prant"> | <strong>प्रांत:</strong> {{ appliedFilters.prant }}</span>
                        <span *ngIf="appliedFilters.receiptType"> | <strong>पावती प्रकार:</strong> {{ appliedFilters.receiptType }}</span> -->

                         <span *ngIf="appliedFilters.country && appliedFilters.country.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>देश:</strong> <strong>{{ appliedFilters.country }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.state && appliedFilters.state.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>राज्य:</strong> <strong>{{ appliedFilters.state }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.district && appliedFilters.district.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>जिल्हा:</strong> <strong>{{ appliedFilters.district }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.taluka && appliedFilters.taluka.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>तालुका:</strong> <strong>{{ appliedFilters.taluka }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.subscriptionType && appliedFilters.subscriptionType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>वर्गणी प्रकार:</strong> <strong>{{ appliedFilters.subscriptionType }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.rep && appliedFilters.rep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रतिनिधी:</strong> <strong>{{ appliedFilters.rep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.officerep && appliedFilters.officerep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>कार्यालय प्रतिनिधी:</strong> <strong>{{ appliedFilters.officerep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.prant && appliedFilters.prant.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रांत:</strong> <strong>{{ appliedFilters.prant }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.receiptType && appliedFilters.receiptType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>पावती प्रकार:</strong> <strong>{{ appliedFilters.receiptType }}</strong>
                        </span>	 
                        
                    </small>
                </span>
            </th>

            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ startdate | date:'dd-MM-yyyy' }}
            </th>
            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              पर्यंत - {{ enddate | date:'dd-MM-yyyy' }}
            </th>
          </tr>


            <!-- <tr>
              <th *ngIf="totalth == 11" colspan="04" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 12" colspan="05" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 13" colspan="06" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 14" colspan="07" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 15" colspan="08" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 16" colspan="09" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 17" colspan="10" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 18" colspan="11" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 19" colspan="12" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 20" colspan="13" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 21" colspan="14" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 22" colspan="15" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 23" colspan="16" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 24" colspan="17" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 25" colspan="18" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 26" colspan="19" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 27" colspan="20" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 28" colspan="21" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 29" colspan="22" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 30" colspan="23" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 31" colspan="24" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 32" colspan="25" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 33" colspan="26" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 34" colspan="27" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 35" colspan="28" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 36" colspan="29" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 37" colspan="30" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 38" colspan="31" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 39" colspan="32" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 40" colspan="33" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 41" colspan="34" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 42" colspan="35" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 43" colspan="36" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 44" colspan="37" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 45" colspan="38" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 46" colspan="39" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 47" colspan="40" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 48" colspan="41" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
              <th *ngIf="totalth == 49" colspan="42" class="largeHeading" style="text-align: center; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हिंदुस्थान प्रकाशन संस्था - विवेक
                साप्ताहिक - वर्गणी विभाग
              </th>
             
              <th *ngIf="totalth >= 10" colspan="6" style="border-top: 2px solid black;"></th>
              <th *ngIf="totalth >= 10" colspan="3" style="text-align: end; font-size: 10px; border-right: 2px solid black; border-top: 2px solid black; border-left: 2px solid black; text-align: center; font-size: 12px;">दिनांक - {{ today | date:'dd-MM-yyyy' }}</th>
              
            </tr> -->
            <!-- <tr>
              <th *ngIf="totalth == 10" colspan="03" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 11" colspan="04" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 12" colspan="05" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 13" colspan="06" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 14" colspan="07" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 15" colspan="08" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 16" colspan="09" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 17" colspan="10" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 18" colspan="11" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 19" colspan="10" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 20" colspan="13" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 21" colspan="14" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 22" colspan="15" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 23" colspan="16" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 24" colspan="17" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 25" colspan="18" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 26" colspan="19" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 27" colspan="20" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 28" colspan="21" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 29" colspan="22" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 30" colspan="23" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 31" colspan="24" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 32" colspan="25" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 33" colspan="26" class="fontBold" style="text-align: center; font-size: 11px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 34" colspan="27" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 35" colspan="28" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 36" colspan="29" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 37" colspan="30" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 38" colspan="31" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 39" colspan="32" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 40" colspan="33" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 41" colspan="34" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 42" colspan="35" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 43" colspan="36" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 44" colspan="37" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 45" colspan="38" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 46" colspan="39" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 47" colspan="40" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 48" colspan="41" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth == 49" colspan="42" class="fontBold" style="text-align: center; font-size: 12px; border-left: 2px solid black;">
                <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> जिल्हानुसार
              </th>
              <th *ngIf="totalth >= 10" colspan="3" style="border-top: 2px solid black;"></th>
              <th *ngIf="totalth >= 10" colspan="3" style="border-top: 2px solid black; border-left: 2px solid black; text-align: center; font-size: 12px;"> दिनांक पासून- {{ startdate | date:'dd-MM-yyyy' }}</th>
              <th *ngIf="totalth >= 10" colspan="3" style="border-right: 2px solid black; border-top: 2px solid black; border-left: 2px solid black; text-align: center; font-size: 12px;">पर्यंत - {{ enddate | date:'dd-MM-yyyy' }}</th>
            </tr> -->
            <tr style="text-align: center;">
              <th rowspan="2" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; font-weight: bold; font-size: 12px;">देश</th>
              <th rowspan="2" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; font-weight: bold; font-size: 12px;">राज्य</th>
              <th rowspan="2" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; font-weight: bold; font-size: 12px;">जिल्हा </th>
              <!-- <th rowspan="2">तालूका </th> -->
              <th colspan="4" style="font-size: 12px; border-left: 2px solid black; border-top: 2px solid black; font-weight: bold; border-bottom: 2px solid black;">एकूण</th>
              <ng-container *ngFor="let data of subTypesName">
                <th *ngIf="data.isVisible" colspan="4" style="font-size: 12px; border-left: 2px solid black; border-top: 2px solid black; border-right: 2px solid black; font-weight: bold;">{{ data.name }}</th>
    
              </ng-container>
            </tr>
            <tr>
              <th style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word; font-size: 12px;">वर्गणीदार संख्या</th>
              <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word; font-size: 12px;">रक्कम</th>
              <th style="font-size: 12px; border-right: 2px solid black;">नवीन</th>
              <th style="border-right: 2px solid black; word-wrap: break-word; font-size: 12px;">नूतनीकरण</th>
              <ng-container *ngFor="let data of subTypesName">
                <th *ngIf="data.isVisible" style="border-left: 2px solid black; border-top: 2px solid black; border-right: 2px solid black; font-size: 12px;">नवीन</th>
                <th *ngIf="data.isVisible"  style="border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black; word-wrap: break-word; font-size: 12px;">नूतनीकरण</th>
                <th *ngIf="data.isVisible"  style="border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black; word-wrap: break-word; font-size: 12px;">एकूण</th>
                <th *ngIf="data.isVisible"  style="font-size: 12px; border-right: 2px solid black; border-top: 2px solid black; font-weight: bold; word-wrap: break-word;">रक्कम</th>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let data of finalData; let i = index">
              <tr>
                <!-- Country -->
                <td 
                  [ngStyle]="{ 'font-weight': i === finalData.length - 1 ? 'bold' : 'normal' }"
                  style="word-wrap: break-word; border-left: 2px solid black; border-bottom: 2px solid black;">
                  <ng-container *ngIf="i === 0 || finalData[i - 1]['country'] !== data['country']">
                    {{ data['country'] }}
                  </ng-container>
                </td>
            
                <!-- State -->
                <td 
                  [ngStyle]="{ 'font-weight': i === finalData.length - 1 ? 'bold' : 'normal' }"
                  style="word-wrap: break-word; border-bottom: 2px solid black; border-left: 2px solid black; border-right: 2px solid black;">
                  <ng-container *ngIf="i === 0 || finalData[i - 1]['state'] !== data['state']">
                    {{ data['state'] }}
                  </ng-container>
                </td>
            
                <!-- District -->
                <td 
                  [ngStyle]="{ 'font-weight': i === finalData.length - 1 ? 'bold' : 'normal' }"
                  style="word-wrap: break-word; border-right: 2px solid black; border-bottom: 2px solid black;">
                  <ng-container *ngIf="i === finalData.length - 1; else showDistrict">
                    <strong>एकूण :</strong>
                  </ng-container>
                  <ng-template #showDistrict>
                    <ng-container *ngIf="i === 0 || finalData[i - 1]['district_name'] !== data['district_name']">
                      {{ data['district_name'] }}
                    </ng-container>
                  </ng-template>
                </td>
            
                <!-- Totals -->

                <td 
                  [ngStyle]="{ 'font-weight': i === finalData.length - 1 ? 'bold' : 'normal' }"
                  style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black; text-align: right;">
                  {{ (data['नवीन'] || 0) + (data['नूतनीकरण'] || 0) }}
                </td>
                <td 
                  [ngStyle]="{ 'font-weight': i === finalData.length - 1 ? 'bold' : 'normal' }"
                  style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black; text-align: right;">
                  {{ data['एकूण'] }}
                </td>
                <td 
                  [ngStyle]="{ 'font-weight': i === finalData.length - 1 ? 'bold' : 'normal' }"
                  style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black; text-align: right;">
                  {{ data['नवीन'] }}
                </td>
                <td 
                  [ngStyle]="{ 'font-weight': i === finalData.length - 1 ? 'bold' : 'normal' }"
                  style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black; text-align: right;">
                  {{ data['नूतनीकरण'] }}
                </td>
            
                <!-- Subtypes -->
                <ng-container *ngFor="let sub of subTypesName">
                  <ng-container *ngIf="sub.isVisible">
                    <td 
                      [ngStyle]="{ 'font-weight': i === finalData.length - 1 ? 'bold' : 'normal' }"
                      style="border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black; text-align: right;">
                      {{ data[getKey(sub.name) + '_नवीन'] || 0 }}
                    </td>
                    <td 
                      [ngStyle]="{ 'font-weight': i === finalData.length - 1 ? 'bold' : 'normal' }"
                      style="border-top: 2px solid black; border-bottom: 2px solid black; text-align: right; border-left: 1px solid black; border-right: 1px solid black;">
                      {{ data[getKey(sub.name) + '_नूतनीकरण'] || 0 }}
                    </td>
                    <td [ngStyle]="{ 'font-weight': i === finalData.length - 1 ? 'bold' : 'normal' }"
                      style="border-top: 2px solid black; border-bottom: 2px solid black; border-left: 1px solid black; border-right: 1px solid black; text-align: right;">
                      {{ (data[getKey(sub.name) + '_नवीन'] || 0) + (data[getKey(sub.name) + '_नूतनीकरण'] || 0) }}
                    </td>
                    <td 
                      [ngStyle]="{ 'font-weight': i === finalData.length - 1 ? 'bold' : 'normal' }"
                      style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black; text-align: right;">
                      {{ data[getKey(sub.name) + '_एकूण'] || 0 }}
                    </td>
                  </ng-container>
                </ng-container>
              </tr>
            </ng-container>
            
            
          </tbody>
        </table>
      </div>
    </div>

    <div style="text-align: center; padding-right: 38%;">
      <div style="margin-left: 70%; margin-bottom: 2%">

        <button class="noPrint" style="margin-top: 2% 2% 0 2%;" (click)="exportExcel('Districtwise_Subscription_Bussiness_Report')"
        mat-raised-button color="primary">
        Export
       </button> 
        <!-- <button
          [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px', 'font-size':'14px', 'font-weight':'600', 'text-align':'center'}, th : {'border': 'solid 1px', 'font-size':'16px', 'font-weight':'600', 'text-align':'center'}, div : {'font-size':'14px', 'font-weight':'600'}, span : {'font-size':'14px', 'font-weight':'600', 'float':'left'}}"
          class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
          printSectionId="print-section" ngxPrint>
          Print
        </button> -->

        <button class="noPrint"
        style="margin-top: 2%; margin-left: 2%"
        mat-raised-button color="primary"
        (click)="printPage()">
         Print
       </button>
       
        <button mat-dialog-close class="btn noPrint">
          Close
        </button>
      </div>
    </div>
   
  </ng-container>
  <div *ngIf="isLoading" class="main-loading">
    <span class="loader"></span>
    <p>Loading...</p>
  </div>